/***
 * File name: table.js
 *
 * Program Description:
 * This file contains all the meta configuration of theSubsectors table in Sectors
 * master data
 *
 * Includes the ff:
 * - Name, collection name, label and other static values for the table
 * - Route definitions
 * - Binded varibles
 * - Advanced query when fetching data list
 * - Privilege name for role restrictions
 * - Table columns indicated as fields
 * - Action buttons on top of the table indicated as tableActions
 * - Action buttons per item inside the table indicated as entryActions
 * - Breadcrumbs definition
 *
 */
export default function (vm) {
  return {
    name: 'SectorTable',
    collectionName: 'sector',
    dataView: 'default',
    label: 'Sector',
    tableHeader: 'Sectors',
    route: {
      updateMultiple: 'sector',
      list: 'sector',
      deleteMultiple: 'sector',
      upload: 'sector'
    },
    vBind: {
      singleSelect: true
    },
    advancedQuery: {
      type: 'sector'
    },
    hideSelect: true,
    privilege: 'canViewAllSector',
    fields: [
      {
        columnHeader: {
          sortable: true,
          text: 'Sector',
          value: 'value'
        }
      }
    ],
    tableActions: [
      {
        id: 'create',
        label: 'Add',
        icon: 'mdi-plus',
        color: 'white',
        vBind: {
          style: 'background-color: #162b54'
        },
        privilege: 'canPostSector',
        action: () => {
          vm.$emit('modalChange', 'create', 'sector')
        }
      }
    ],
    entryActions: [
      {
        id: 'view',
        icon: 'mdi-eye',
        privilege: 'canViewSector',
        action: (item) => {
          vm.$emit('modalChange', 'view', 'sector', item._id)
        }
      },
      {
        id: 'edit',
        icon: 'mdi-pencil',
        privilege: 'canViewSector',
        action: (item) => {
          vm.$emit('editRow', 'edit', 'sector', item._id)
        }
      },
      {
        id: 'del',
        icon: 'mdi-delete',
        privilege: 'canDeleteSector',
        action: (item) => {
          vm.$emit('deleteRow', 'delete', 'sector', item._id)
        }
      }
    ],
    breadcrumbs: {
      divider: '/',
      large: true,
      items: [
        {
          text: 'Sector'
        }
      ]
    }
  }
}
